import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllJobs, SavedJobs } from "../../store/jobSlice";
import JobList from "../Jobs/JobList";
import QuoteCard from "../../templates/QuoteCard";
import AdCard from "../../templates/AdCard";
// import AdCard from "../../templates/AdCard"; // Commented for Auto Ads setup

export default function Internship() {
  const dispatch = useDispatch();
  const { jobs, savedJobs, savedJobsStale } = useSelector((state) => state.job);
  const [filter, setFilter] = useState("all");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const user = useSelector((state) => state.auth.user);
  const jobsStale = useSelector((state) => state.job.jobsStale["Internship"]);

  // Fetch saved jobs if user selects "saved"
  useEffect(() => {
    if (filter === "saved" && savedJobsStale && user) {
      dispatch(SavedJobs({ UserId: user.$id }));
    }
  }, [filter, dispatch, savedJobsStale, user]);

  // Fetch internships if stale
  useEffect(() => {
    if (jobsStale) {
      dispatch(getAllJobs("Internship"));
    }
  }, [dispatch, jobsStale]);

  // Handle outside click for dropdown
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [dropdownRef]);

  const handleFilter = (type) => {
    setFilter(type);
    setIsDropdownOpen(false);
  };

  const filteredJobs =
    filter === "all"
      ? jobs.filter((job) => job.Type === "Internship")
      : jobs.filter(
          (job) => job.Type === "Internship" && savedJobs.includes(job.$id)
        );

  return (
    <div className="min-h-screen bg-gray-50 ">
      <div className="mt-28 px-2">
        <QuoteCard />
      </div>
      {/* --- Top Banner Ad (Commented for Auto Ads) --- */}
      {/* 
      <div className="fixed top-[80px] left-0 w-full z-40 bg-gray-50/95 backdrop-blur-md">
        <div className="max-w-7xl mx-auto px-6 py-3">
          {filteredJobs.length > 0 && (
            <AdCard
              size="banner"
              className="rounded-2xl shadow-md bg-gradient-to-r from-purple-500 to-indigo-500 text-white"
            />
          )}
        </div>
      </div>
      */}

      {/* --- Main Content --- */}
      <div className="max-w-7xl mx-auto px-6 pt-[100px]">
        <div className="flex items-center justify-between mb-8 border-b-4 border-pink-500 pb-2">
          <h2 className="text-3xl font-bold text-gray-800">Internships</h2>

          {/* Dropdown filter */}
          <div className="relative inline-block text-left" ref={dropdownRef}>
            <button
              type="button"
              onClick={() => setIsDropdownOpen(!isDropdownOpen)}
              className="inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50"
            >
              Filter:{" "}
              {filter === "all" ? "All Internships" : "Saved Internships"}
              <svg
                className="-mr-1 ml-2 h-5 w-5"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
              >
                <path
                  fillRule="evenodd"
                  d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.08 1.04l-4.25 4.25a.75.75 0 01-1.08 0L5.21 8.27a.75.75 0 01.02-1.06z"
                  clipRule="evenodd"
                />
              </svg>
            </button>

            {isDropdownOpen && (
              <div className="origin-top-right absolute right-0 mt-2 w-40 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-10">
                <div className="py-1">
                  <button
                    onClick={() => handleFilter("all")}
                    className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                  >
                    All Internships
                  </button>
                  <button
                    onClick={() => handleFilter("saved")}
                    className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                  >
                    Saved Internships
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Job Listings */}
        <JobList jobs={filteredJobs} adFrequency={0} jobsPerPage={90} />

        <section className="max-w-6xl mx-auto px-4 mb-3">
          <AdCard slot="9326257490" format="fluid" />
        </section>

        {/* --- Sidebar and Bottom Ads Removed for Full Width --- */}
        {/* 
        <div className="hidden lg:flex lg:col-span-3 justify-center">
          <div className="sticky top-32 h-[600px] w-full">
            {filteredJobs.length > 0 && (
              <AdCard
                size="large"
                className="h-full w-full rounded-xl shadow-lg bg-gradient-to-b from-green-400 to-teal-500 text-white"
              />
            )}
          </div>
        </div>

        <div className="lg:col-span-12 mt-12">
          {filteredJobs.length > 0 && (
            <AdCard
              size="banner"
              className="rounded-2xl shadow-md bg-gradient-to-r from-indigo-600 to-teal-500 text-white"
            />
          )}
        </div>
        */}
      </div>
    </div>
  );
}
